import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { formatDate } from '../../services/service-utils';

export interface ThInputCheckboxProps {
  label: string;
  value: boolean;
  onChange?: (value: string) => void;
}

function ThInputCheckBox({ label, value, onChange }: ThInputCheckboxProps) {
  const [isValid, setIsValid] = useState<boolean | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Form.Group
      controlId={label.replace(/\s+/g, '')}
    >
      <Form.Check
        className='th-input-checkbox'
        label={label}
        type='checkbox'
        onChange={handleChange}
        isInvalid={isValid === false}
        isValid={isValid === true}
      />
      <Form.Control.Feedback type='invalid'>
        {label} is required.
      </Form.Control.Feedback>
    </Form.Group>
  );
}

export default ThInputCheckBox;
